var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 max-w-screen-sm mx-auto rounded bg-red-300"},[_c('h1',{staticClass:"mb-2 text-xl"},[_vm._v(_vm._s(_vm.title ? _vm.title : "Error"))]),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }